import shopifyDawnGenericDefaults from '../shopify-dawn-generic/config.js';

const getLocalPreselection = (pageType, defaults) => {
  const defaultPreselection = defaults.getter(pageType) || [];

  const productContext = window.Convermax.config?.productContext;
  return productContext
    ? [...defaultPreselection, { field: 'product_context', term: productContext }]
    : defaultPreselection;
};

export default {
  includes: ['shopify-dawn-generic'],
  ...shopifyDawnGenericDefaults,
  getLocalPreselection,
};
